<template>
    <div class=" grid grid-cols-1 md:grid-cols-2 gap-12">
        <form class="text-sm" v-if="ui.status !== 'saved'">

            <div class="mb-5">
                <label for="name" class="block mb-2">Naam</label>
                <input
                    class="w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                    type="text"
                    id="name"
                    placeholder="Uw naam"
                    v-model="formData.name"
                    required>
                <form-error :error-bag-item="ui.errorBag.name"></form-error>

            </div>


            <div class="mb-5">
                <label for="hideFromPublic" class="flex space-x-3 text-gray-500 items-center mb-2">
                    <input type="checkbox" name="hidden" id="hideFromPublic" v-model="formData.hideMyName"/>
                    <span>Uw naam niet publiceren. U moet hem wel invullen.</span>
                </label>
            </div>


            <div class="mb-5">
                <label for="email" class="block mb-2">Email adres (publiceren we nooit)</label>
                <input
                    class="w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                    type="email"
                    id="email"
                    placeholder="Uw email adres"
                    v-model="formData.email"
                    required>
                <form-error :error-bag-item="ui.errorBag.email"></form-error>

            </div>
            <div class="mb-5">
                <label for="city" class="block mb-2">Woonplaats</label>
                <input
                    class="w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded"
                    type="text"
                    id="city"
                    placeholder="Uw woonplaats"
                    v-model="formData.city"
                    required>
                <form-error :error-bag-item="ui.errorBag.place"></form-error>

            </div>
            <div class="mb-5">
                <div class="flex justify-between">
                    <label for="message" class="block mb-2">Waarom support je De Groene Buffer</label>
                    <div>Nog <span class="font-bold" v-text="charsLeftInMessage"></span> tekens</div>
                </div>
                <textarea
                    class="w-full px-4 py-3 mr-3 text-base text-gray-800 placeholder-gray-200 border-2 border-gray-300 rounded h-24"
                    type="text"
                    id="message"
                    maxlength="160"
                    placeholder="Ik support de Groene Buffer omdat..."
                    v-model="formData.message"
                    required>
                            </textarea>
                <form-error :error-bag-item="ui.errorBag.text"></form-error>

            </div>
            <div>
                <button
                    class="flex items-center px-4 py-4 ml-auto font-medium text-white bg-green-200 rounded hover:bg-orange"
                    type="submit"
                    @click.prevent="submit">
                    <template v-if="ui.status === 'sending'">versturen...</template>
                    <template v-else>
                        Word supporter
                        <svg aria-hidden="true"
                             focusable="false"
                             data-prefix="far"
                             data-icon="long-arrow-right"
                             class="w-3 ml-2 svg-inline--fa fa-long-arrow-right fa-w-14"
                             role="img"
                             xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 448 512">
                            <path fill="currentColor"
                                  d="M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"></path>
                        </svg>
                    </template>

                </button>
            </div>


        </form>
        <div class="bg-green-200 rounded-md p-4 text-white" v-if="ui.status === 'saved'">
            <h2 class="mb-3 text-2xl">Welkom Supporter!</h2>
            <p>Om uw supporterschap direct kracht bij te zetten hoeft u enkel nog op de link in de email te klikken.</p>
        </div>

        <div>
            <div
                class="bg-white py-5 px-10 rounded border-l-2 border-green-400 h-auto shadow-lg flex flex-col justify-between">
                <p class="mb-3">
                    <template v-if="formData.message">{{  formData.message }}</template>
                    <template v-if="!formData.message">Ik support De Groene Buffer omdat...</template>
                </p>
                <div>
                    <span class="block text-gray-800 font-medium">{{ displayName }}</span>
                    <div class="flex space-x-3 items-center">
                        <svg
                            data-name="Layer 1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512"
                            class="w-auto h-5"
                        >
                            <path
                                d="M192 0C85.9 0 0 86 0 192c0 71.12 24 93.34 151.27 297.42 18.79 30.12 62.69 30.09 81.46 0C360.08 285.23 384 263.1 384 192 384 85.9 298 0 192 0zm0 464C64.58 259.69 48 246.79 48 192a144 144 0 01288 0c0 54.55-15.17 65.42-144 272zm-80-272a80 80 0 1180 80 80 80 0 01-80-80z"
                                fill="#84aa06"/>
                        </svg>
                        <span class="text-green-200" id="cityPreview">
                            <template v-if="formData.city">{{  formData.city }}</template>
                            <template v-if="!formData.city">Uw woonplaats</template>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "supporter-form",
    data: function () {
        return {
            ui: {
                status: 'form',
                maxChars: 160,
                errorBag: []
            },
            formData: {
                name: '',
                email: '',
                city: '',
                message: '',
                hideMyName: false
            },
        }
    },
    computed: {
        displayName: function () {
            if (this.formData.hideMyName) {
                return 'Anoniem';
            }
            if (this.formData.name.length === 0) {
                return 'Uw naam';
            }

            return this.formData.name;
        },

        charsLeftInMessage: function () {
            if (this.formData.message.length > 160) {
                return 0;
            }

            return 160 - this.formData.message.length;
        }

    },
    methods: {
        setDonationAmount(donation) {
            this.selectedDonation = donation;

            if (donation.valueType === 'custom') {
                this.$nextTick(() => {
                    this.$refs.donationAmount[0].focus()
                })
            }

        },
        submit: function () {
            if (this.ui.status === 'sending'){
                return;
            }

            this.ui.status = 'sending';
            this.ui.errorBag = [];

            const token = document.getElementById('app').dataset.token;

            axios.post('/api/supporter',
                {
                    _token: token,
                    name: this.formData.name,
                    place: this.formData.city,
                    text: this.formData.message,
                    email: this.formData.email,
                    hide_my_name: this.formData.hideMyName
                },
                {
                    validateStatus: (status) => status === 200 || status === 422
                }
            ).then((response) => {
                if(response.status === 422){
                    this.ui.errorBag = response.data.errors;
                    this.ui.status = 'error';

                    return;
                }

                console.log(response.data);
                this.ui.status = response.data.status;
                // window.location.href = response.data.checkoutUrl;
            }).catch(function (response) {
                // console.log(response);
            })

        }
    }
}
</script>


